import { InfoModal } from "@newsela/angelou";

import {
  modalRootCss,
  modalBodyCss,
  modalFooterCss,
  modalContentWrapperCss,
} from "./AssignmentDeleteModal.style";
import ModalFooterActions from "./ModalFooterActions";

interface DeleteModal {
  closeDeleteModal: () => void;
  deleteAssignmentModalProps: object;
  isDraftAssignment: boolean;
  triggerRef: React.Ref<HTMLButtonElement> | null;
}

export const DRAFT_ASSIGNMENT_MESSAGE =
  "Are you sure you want to delete this assignment?";
export const PUBLISHED_ASSIGNMENT_MESSAGE =
  "Deleting this assignment will unassign it from your classes. Are you sure you want to delete this assignment?";

const AssignmentDeleteModal = ({
  closeDeleteModal,
  deleteAssignmentModalProps,
  isDraftAssignment,
  triggerRef,
}: DeleteModal) => {
  const deleteMessage = isDraftAssignment
    ? DRAFT_ASSIGNMENT_MESSAGE
    : PUBLISHED_ASSIGNMENT_MESSAGE;

  return (
    <InfoModal
      labelId="DeleteAssignment"
      title="Delete Assignment?"
      {...deleteAssignmentModalProps}
      __cssFor={{
        root: modalRootCss,
        modalContentWrapper: modalContentWrapperCss,
        scrollableBody: modalBodyCss,
        footer: modalFooterCss,
      }}
      footer={<ModalFooterActions closeDeleteModal={closeDeleteModal} />}
      triggerRef={triggerRef}
    >
      {deleteMessage}
    </InfoModal>
  );
};

export default AssignmentDeleteModal;
